import axios from 'axios'

const baseURL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_URL : process.env.VUE_APP_URL_LOCAL
const tokenUser = localStorage.getItem('token')
const typeToken = localStorage.getItem('type_token')
const token = (typeToken || '') + ' ' + (tokenUser || '')

const _axios = axios.create({
    baseURL: baseURL,
    headers: {
      Authorization: token
    }
})
axios.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = token
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      if (error.response.status === 401) {
        /* await store.dispatch({
            type: 'REMOVE_USER',
        }); */
      }
      return Promise.reject(error)
    }
  )

export default _axios
